<template>
  <div class="row">
    <div class="col-md-12 mt-3">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>CPE Domain:</label>
          <div class="input-group">
            <input v-model="cpe.hostName" type="text" class="form-control" disabled/>
            <div class="input-group-append">
              <button @click="copySSH" class="btn btn-info" v-tooltip="'Copy Command'"><i class="fa fa-clipboard"></i></button>
              <button @click="openSSH" class="btn btn-green" v-tooltip="'Open SSH'"><i class="fa-solid fa-terminal"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>User:</label>
          <div class="input-group">
            <input v-model="cpe.username" type="text" class="form-control"/>
          </div>
        </div>
      </div>
      <div class="form-row justify-content-between mt-3" v-allowed:view="['STAFF']">
        <div class="form-group col-auto">
          <button type="button" @click="updateCpe()" class="btn btn-success">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      cpe: {
        type: Object,
        required: true
      },
      saleNumber: {
        type: String,
        required: true
      }
    },
    components: {
      
    },
    methods: {
      openSSH() {
        window.open(`ssh://${this.cpe.username}@${this.cpe.hostName}`);
      },
      copySSH() {
        this.$copyText(`ssh ${this.cpe.username}@${this.cpe.hostName}`);
        this.showSuccess("SSH Command added to clipboard");
      },
      updateCpe() {
        this.$http.put(`${this.$config.aimsAPI}sales/cpe/update`, this.cpe).then(
            (response) => {
              this.showSuccess("CPE Updated");
              this.$emit('saveSale')
            },
            (error) => {
              console.error(error);
              this.showError("Error Updating CPE", error);
            }
          );
      }
    },
  }

</script>

<style>

</style>
